import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Farsi from "../../lang/Farsi";
import English from "../../lang/English";

export const Context = React.createContext();

class RenderLanguage extends Component {

    state = {
        local: "fa",
        lang: Farsi,
        direction: "rtl"
    }

    languageHandler = (e) => {
        const value = e.target.value;

        if (value === "en") {
            this.setState({
                local: "en",
                lang: English,
                direction: "ltr"
            })
        } else {
            this.setState({
                local: "fa",
                lang: Farsi,
                direction: "rtl"
            })
        }
    }


    render() {
        const { local, lang, direction } = this.state;
        return (
            <HelmetProvider>
                <Context.Provider value={{ language: this.languageHandler }}>
                    <IntlProvider locale={local} messages={lang}>
                        <Helmet htmlAttributes={{ lang: local, dir: direction }} ></Helmet>
                        {this.props.children}
                    </IntlProvider>
                </Context.Provider>
            </HelmetProvider>
        )
    }
}

export default RenderLanguage;